<template>
  <div class="back-box">
    <div class="back" @click="backClick">
      <img class="img" src="../assets/image/back.png" alt />
      <div class="text">返回</div>
    </div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  components: {},
  // 定义属性
  data() {
    return {};
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    backClick() {
      localStorage.setItem('keyword', "keyword")
      this.$router.go(-1);
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang='scss' scoped>
.back-box {
  padding: 25px 0;
  background-color: rgba(7, 31, 82, 0.2);
  border: 2px solid rgba(164, 196, 230, 0.2);
 	height: calc(100% - 150px);
  margin: 20px 30px;
  .back {
    display: flex;
    align-items: center;
    padding: 0px 18px;
    cursor: pointer;
    .text {
      color: white;
      font-size: 18px;
      margin-left: 6px;
    }
    .img {
      width: 30px;
			height: 30px;
			margin-right: 10px;
    }
  }
}
</style>
